export default __webpack_public_path__ + "static/media/Event5-2.a95adb04.gif";